var map = {
	"./feature_buy_en.png": 88522,
	"./feature_buy_id.png": 40020,
	"./feature_buy_my.png": 3037,
	"./feature_buy_ph.png": 65259,
	"./feature_buy_th.png": 50391,
	"./feature_buy_zh.png": 99741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44516;